import axios from "axios";
import { LoggingConstants } from "Constants";
import { AxiosHelperSingleton, PendoHelperSingleton } from "Helpers";
import { TSpecificationUnitDTO } from "Types";


export class SpecificationUnitController {

    public async createAsync(specificationUnit: TSpecificationUnitDTO, isFromDelivery: boolean): Promise<TSpecificationUnitDTO> {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}SearchUnitCreate`, {
            queryId: specificationUnit.savedQueryId
        });
        
        const result = await axios.post<TSpecificationUnitDTO>(`${AxiosHelperSingleton.getServerBaseURL()}api/specificationunits?isFromDelivery=${isFromDelivery ? "true" : "false"}`,
            specificationUnit);
        return result.data;
    }

    public async updateAsync(specificationUnit: TSpecificationUnitDTO, isFromDelivery: boolean) {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}SearchUnitUpdate`, {
            actionObjectId: specificationUnit.id
        });
        
        const result = await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}api/specificationunits/${specificationUnit.id}/edit?isFromDelivery=${isFromDelivery ? "true" : "false"}`,
            specificationUnit);
        return result.status === 200;
    }

    public async deleteAsync(id: number, isFromDelivery: boolean): Promise<boolean> {
        PendoHelperSingleton.trackEventWithProperties(`${LoggingConstants.DYNAMIC_DELIVERY}SearchUnitDelete`, {
            actionObjectId: id
        });
        
        const result = await axios.post(`${AxiosHelperSingleton.getServerBaseURL()}api/specificationunits/${id}/delete?isFromDelivery=${isFromDelivery ? "true" : "false"}`);
        return result.status === 200;
    }
}

export const SpecificationUnitControllerSingleton = new SpecificationUnitController(); 